import type { Product } from '../types';

const IMG = 'https://healthshoplongevity.com/img';

const DEFAULT_NEUROMODULATION_USAGE_WARNING =
  'Kalp pili, implante elektronik cihaz veya epilepsi/nöbet öyküsü bulunan kişilerin cihazı kullanmadan önce hekimlerine danışmaları önerilir.';

export const seedProducts: Product[] = [
  {
    id: 1,
    slug: 'tdcs-cihazi',
    name: 'TDCS Cihazı',
    description:
      'DOMAS 9128h model tDCS cihazı. Baş ve saçlı deri bölgesine uygulanan transkraniyal doğru akım stimülasyonu ile baş ağrısı, odaklanma ve uyku desteği sağlar.',
    price: 350,
    currency: 'TRY',
    category: 'tDCS',
    images: [
      `${IMG}/tdcs1.png`,
      `${IMG}/tdcs2.png`,
      `${IMG}/tdcs3.png`,
      `${IMG}/tdcs4.png`,
      `${IMG}/tdcs5.png`,
    ],
    benefits: ['Baş ağrısı', 'Odaklanma', 'Uyku desteği'],
    stock: 15,
    inStock: true,
    specs: {
      'Ürün Tipi': 'tDCS Cihazı',
      Marka: 'DOMAS',
      Model: '9128h',
    },
    usageWarning: DEFAULT_NEUROMODULATION_USAGE_WARNING,
  },
  {
    id: 2,
    slug: 'ces-cihazi',
    name: 'CES Cihazı',
    description:
      'M008 model kraniyal elektrik stimülasyonu cihazı. Uykuya yardımcı taşınabilir CES cihazı.',
    price: 250,
    currency: 'TRY',
    category: 'CES',
    images: [`${IMG}/ces1.png`, `${IMG}/ces2.png`],
    benefits: ['Uyku desteği', 'Taşınabilir', 'USB-C şarj'],
    stock: 8,
    inStock: true,
    specs: { 'Ürün Tipi': 'CES Cihazı', Model: 'M008' },
    usageWarning: DEFAULT_NEUROMODULATION_USAGE_WARNING,
  },
  {
    id: 3,
    slug: 'nord-hidrojenli-su-sisesi',
    name: 'Nord Hidrojenli Su Şişesi',
    description:
      '280 mL kapasiteli hidrojenli su şişesi. 3500-5000 ppb hidrojen konsantrasyonu.',
    price: 100,
    currency: 'TRY',
    category: 'Hidrojen',
    images: [`${IMG}/h2o1.jpeg`, `${IMG}/h2o2.jpeg`, `${IMG}/h2o3.jpeg`],
    benefits: ['3500-5000 ppb H₂', 'SPE/PEM teknolojisi', 'Taşınabilir'],
    stock: 20,
    inStock: true,
    specs: { Kapasite: '280 mL' },
  },
  {
    id: 4,
    slug: 'led-isik-terapisi',
    name: 'LED Işık Terapisi',
    description: 'Güneş ışığı lambası / LED ışık terapisi cihazı. 140 adet 4014 LED.',
    price: 0,
    currency: 'TRY',
    priceLabel: 'Fiyat için iletişime geçin',
    category: 'Işık Terapisi',
    images: [`${IMG}/light01.jpeg`, `${IMG}/light02.jpeg`],
    benefits: ['Işık terapisi', '50.000 saat ömür', 'Ev kullanımı'],
    stock: 0,
    inStock: false,
    specs: { 'LED Sayısı': '140 Adet' },
  },
];

export const DEFAULT_CATEGORIES = ['tDCS', 'CES', 'Hidrojen', 'Işık Terapisi'] as const;
